/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, $Container, $GraphicsBox, ContainerProps, CanBeSignals} from '@gongxigames/framework/core/fragments/BuilderY';
import {RUnit, Padding} from '@gongxigames/framework/core/fragments/display/responsive';
import {Container as PixiContainer, Graphics as PixiGraphics} from 'pixi.js';
import {COLOR_POPUP_BG, COLOR_POPUP_BG3} from '@gongxigames/framework/slotV2/ui/ui-ruby/CONSTANTS';
import {$Header, HeaderProps} from './Header';
import {$PopupFader} from './PopupFader';
import {createPopupPaddingComputed, createPopupTween} from './functions';

export type PopupProps = ContainerProps & HeaderProps & CanBeSignals<{
    show: boolean;
    width?: RUnit;
    height?: RUnit;
    padding?: Padding;
}>;

export const $Popup: FC<PopupProps> = (props) => {
    const mask = new PixiGraphics();
    const popupContainer = new PixiContainer();
    const popupAnimationContainer = new PixiContainer();
    const popupContentResponsiveConf = createPopupPaddingComputed(props);

    popupContainer.mask = mask;

    createPopupTween(props, popupAnimationContainer);

    return <$Container
        name='popupRoot'
        responsive={{
            box: {width: '100%', height: '100%', x: '50%', y: '50%'}
        }}
    >
        <$PopupFader show={props.show}/>
        <$Container
            name='popupAnimationContainer'
            instance={popupAnimationContainer}
        >
            <$Container
                instance={popupContainer}
                name='popup'
                responsive={props.responsive}
            >
                <$GraphicsBox
                    name='mask'
                    instance={mask}
                    responsive={{box: {width: '100%', height: '100%'}}}
                    responsiveBoxSize
                    boxColor={0xffffff}
                    boxBorderRadius={24}
                />
                <$GraphicsBox
                    name='content'
                    responsive={popupContentResponsiveConf}
                    responsiveBoxSize
                    boxColor={COLOR_POPUP_BG}
                >
                    {props.children}
                </$GraphicsBox>
                <$Header {...props}/>
                <$GraphicsBox
                    name='outline'
                    responsive={{box: {width: '100%', height: '100%'}}}
                    responsiveBoxSize
                    boxAlpha={0}
                    boxOutlineColor={COLOR_POPUP_BG3}
                    boxOutlineAlignment={0}
                    boxOutlineWidth={3}
                    boxBorderRadius={24}
                />
            </$Container>
        </$Container>
    </$Container>;
};
